<template>
    <v-card>
        <v-toolbar flat dense color="blue-grey" dark>
            <v-toolbar-title>Fakturahistorikk</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear indeterminate v-if="loading"/>
        <p v-else-if="log.length === 0" class="pa-3 text-center grey--text">Ingen fakturaer funnet.</p>
        <v-list v-else class="invoice-list">
            <template v-for="(item, index) in log">
                <div>
                    <v-divider v-if="index > 0"/>
                    <v-list-item :key="item.id">
                        <v-list-item-content>
                            <v-list-item-title>
                                <small class="d-block">
                                    {{ item.dateString }}
                                </small>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ item.interval  }} mnd. intervall
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content>
                            <v-list-item-title>
                                <v-chip small color="green" class="white--text">
                                    {{ item.invoice_number }}
                                </v-chip>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                        </v-list-item-action>
                    </v-list-item>
                </div>
            </template>
        </v-list>
    </v-card>
</template>
<script>
import moment from 'moment';

export default {
    name: 'invoice-list',
    props: [
        'carId',
    ],

    data() {
        return {
            loading: false,
            log: []
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        loadData() {
            this.loading = true;

            this.$http.get(`invoicing/${this.carId}`).then(response => {
                this.log = response.data.data.map(it => {
                    return {
                        ...it,
                        dateString: moment(it.date).format('ll')
                    }
                });
            }).finally(() => this.loading = false);
        }
    },
}
</script>

<style scoped>
.invoice-list {
    padding-top: 0;
    padding-bottom: 0;
    max-height: 500px;
    overflow-y: scroll;
}
</style>
